import { palette } from '../constants';

export const MuiTypography = {
  styleOverrides: {
    root: {
      color: palette.white,
    },
  },
};
